import React from 'react';

interface LoadingAnimationProps {
  className?: string;
}

const LoadingAnimation: React.FC<LoadingAnimationProps> = ({ className = "" }) => {
  return (
    <div className={`flex justify-start px-2 sm:px-0 ${className}`}>
      <div className="bg-gray-100 rounded-lg p-3 sm:p-4 max-w-[85%] sm:max-w-xs">
        <div className="flex items-center space-x-2">
          <div className="flex space-x-1">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
          <span className="text-xs sm:text-sm text-gray-600 ml-2">SERGIC Assistant réfléchit...</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingAnimation;
